import { styled } from '@mui/material/styles';
import { Drawer } from '@sunwisesoftware/sunwise-ui';

import { PADDING, SMALL_SIZE_DRAWER } from '../constants';
import { getDrawerSizeInPX } from '../helpers';

const StyledDrawer = styled(Drawer)(({ drawersize, theme }) => ({
    '& ::-webkit-scrollbar': { width: 0, height: 0 },
    '& .MuiDrawer-paper': {
        overflowX: 'hidden',
        background: theme.palette.background.paper,
        borderRight: 0,
        padding: `${PADDING}px`,
        transition: 'width 225ms cubic-bezier(0, 0, 0.2, 1)',
        width: getDrawerSizeInPX(drawersize),
    },
    '&:hover .toggleDrawer': { visibility: 'visible!important' },
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    width: getDrawerSizeInPX(drawersize),
    [theme.breakpoints.down('sm')]: {
        '& .MuiDrawer-paper': { width: SMALL_SIZE_DRAWER },
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        width: SMALL_SIZE_DRAWER,
    },
}));

export default StyledDrawer;
